export default "mdc-select {\n  border-radius: 0;\n  border-bottom: 0;\n}"